import { QueryState } from 'src/app/core/models/query.model';
import { createTokenQueryServiceInstance } from 'src/app/core/services/query.service';
import { SignalStoreConfig } from 'src/app/shared/functions/store.functions';
import { IPrelievo, getStatusIcon } from './models/prelievo.model';
import { IParametriAlert } from './models/parametri-alert';
import { ParametriObblMancanti } from './models/parametri-obbligatori-mancanti.model';
import { ITableColumn } from 'src/app/core/models/table.model';
import { IControlliDettaglio } from './models/prelievo-dettaglio.model';

export const PRELIEVO_CONTROLLO_SINGOLO_ENDPOINT = 'web-controlli';
export const PRELIEVO_CONTROLLO_SINGOLO_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(PRELIEVO_CONTROLLO_SINGOLO_ENDPOINT);

export const PRELIEVO_EX_ENDPOINT = 'controlli';
export const PRELIEVO_EX_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(PRELIEVO_EX_ENDPOINT);

export const PRELIEVO_ENDPOINT = 'controlli-grouped';
export const PRELIEVO_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(PRELIEVO_ENDPOINT);

export const PARAMETRI_OBBLIGATORI_ENDPOINT = 'controllo/parametri-obbligatori-mancanti';
export const PARAMETRI_OBBLIGATORI_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(PARAMETRI_OBBLIGATORI_ENDPOINT);

export const PARAMETRI_ALERT_ENDPOINT = 'controllo/parametri-alert';
export const PARAMETRI_ALERT_QUERY_SERVICE_INSTANCE = createTokenQueryServiceInstance(PARAMETRI_ALERT_ENDPOINT);

export const prelievoStateConfig: SignalStoreConfig<QueryState<IPrelievo>> = {
  initState: {
    list: [],
    // sort: {
    //   field: 'dataPrelievo',
    //   direction: 'asc'
    // }
  }
}
export const dettaglioStateConfig: SignalStoreConfig<QueryState<IControlliDettaglio>> = {
  initState: {
    list: [],
    // sort: {
    //   field: 'dataPrelievo',
    //   direction: 'asc'
    // }
  }
}
export const statusDefaultIcon: { [key: string]: string } = {
  'ok': 'done',
  'warning': 'warning',
  'alert': 'error'
}

export const statusDefaultTextColor: { [key: string]: string } = {
  'ok': 'text-green-400',
  'warning': 'text-yellow-400',
  'alert': 'text-red-400'
}



export const PARAMETRI_ALERT_COLUMNS_DETTAGLIO: ITableColumn[] = [
  {
    name: 'id',
    label: 'ID',
    field: 'datiPrelievoId',
    primaryKey: true,
    visible: false,
    cell: (element: IParametriAlert) => element.parametro.id,
  },
  {
    name: 'parametro',
    label: 'Parametro',
    field: 'parametro',
    cell: (element: IParametriAlert) => element.parametro.definizione,
  },
  {
    name: 'valoreArrotondato',
    label: 'Valore Arrotondato',
    field: 'valoreArrotondato',
  },
  {
    name: 'valoreRapportoProva2',
    label: 'Valore Rapporto Prova',
    field: 'valoreRapportoProva',
    cell:(element:IParametriAlert)=>element.parametro.tipologia=="qualitativo" ?  "" : (element.valoreRapportoProva!=null ? element.valoreRapportoProva : "")
  },
  {
    name: 'valoreRapportoProva',
    label: 'Valore Accettabile',
    field: 'valoreRapportoProva',
    cell:(element:IParametriAlert)=>element.parametro.tipologia=="qualitativo" ? ( element.valoreRapportoProva==1 ? "SI" : "NO" ) : ""
  },

  {
    name: 'valoreLoq',
    label: 'Valore Loq',
    field: 'valoreLoq',
    cell:(element:IParametriAlert)=>element.valoreLoq!=null ? element.valoreLoq.toString()+element.loq?.toString() : ""
  },
  {
    name: 'valoreLfs',
    label: 'Valore Lfs',
    field: 'valoreLfs',
    cell:(element:IParametriAlert)=>element.valoreLfs!=null ? element.valoreLfs.toString()+element.lfs?.toString() : ""
  },
  {
    name: 'unitaDiMisura',
    label: 'Unità di Misura',
    field: 'unitaDiMisura',
    cell: (element: IParametriAlert) => element.parametro.unitaDiMisura,
  },
/*   {
    name: 'obbligatorio',
    label: 'Obbligatorio',
    field: 'obbligatorio',
    cell: (element: IParametriAlert) => element.parametro.obbligatorio ? 'SI' : 'NO',
  },
  {
    name: 'note',
    label: 'Note',
    field: 'note',
    cell: (element: IParametriAlert) => element.parametro.note != null ? element.parametro.note : '',
  }, */

];






